<template>
	<el-dialog
		:visible.sync="visible"
		title="选择购买版本"
		width="620px"
		:close-on-click-modal="true"
		:close-on-press-escape="true"
		custom-class="dialog-add-cart"
		@close="handleClose"
	>
		<div v-loading="loading" element-loading-text="加载中...">
			<template v-if="!loading && info">
				<!-- 商品基本信息 -->
<!--				<div class="cart-product-info">-->
<!--					<div class="cart-product-header">-->
<!--						<span class="cart-product-code">{{ info.standardCode }}</span>-->
<!--						<span v-if="info.lifeName">-->
<!--							<el-tag :type="lifeTagType" size="mini" effect="dark">{{ info.lifeName }}</el-tag>-->
<!--						</span>-->
<!--						<span v-if="info.standardTypeName">-->
<!--							<el-tag size="mini" type="success" effect="plain">{{ info.standardTypeName }}</el-tag>-->
<!--						</span>-->
<!--					</div>-->
<!--					<h3 class="cart-product-name">{{ info.standardName }}</h3>-->
<!--					<div class="cart-product-meta">-->
<!--						<span v-if="info.publishDate"><i class="el-icon-date"></i> 发布日期：{{ info.publishDate }}</span>-->
<!--						<span v-if="info.executeDate"><i class="el-icon-time"></i> 实施日期：{{ info.executeDate }}</span>-->
<!--					</div>-->
<!--				</div>-->

				<!-- 购买选项列表 -->
<!--				<div class="cart-option-title">选择购买版本</div>-->
				<div class="cart-option-list">
					<!-- 纸质版 -->
					<template v-if="paperProducts.length">
						<div class="cart-type-label">纸质版</div>
						<div
							v-for="(item, idx) in paperProducts"
							:key="'paper_' + idx"
							:class="['cart-option-item', { selected: item.checked }]"
							@click="togglePaper(idx)"
						>
							<el-checkbox v-model="item.checked" class="cart-checkbox" @click.native.stop @change="togglePaper(idx)"></el-checkbox>
							<div class="cart-option-left">
<!--								<div class="cart-option-icon paper">-->
<!--									<i class="el-icon-document"></i>-->
<!--								</div>-->
								<div class="cart-option-info">
									<div class="cart-option-name">{{ info.standardCode}} {{ item.prdSpuName || '纸质版' }}</div>
<!--									<div class="cart-option-sku" v-if="item.prdSkuName">{{ item.prdSkuName }}</div>-->
								</div>
							</div>
							<div class="cart-option-right">
								<div class="cart-price-box">
									<div class="cart-price-row">
										<span class="cart-now-price">¥{{ displayPrice(item) }}</span>
										<span class="cart-before-price" v-if="item.defaultPrice && displayPrice(item) < item.defaultPrice">¥{{ item.defaultPrice }}</span>
										<el-tag v-if="calcDiscount(item) !== null" size="mini" type="danger" class="cart-discount-tag">{{ calcDiscount(item) }}折</el-tag>
									</div>
									<div class="cart-vip-row" v-if="!isVipUser && item.vipPrice && item.vipPrice < item.curPrice">
										<span class="cart-vip-price">VIP ¥{{ item.vipPrice }}</span>
									</div>
									<div class="cart-quantity" @click.stop>
										<el-input-number
											v-model="item.curBuyNum"
											:min="1"
											:max="99"
											size="mini"
											controls-position="right"
										></el-input-number>
									</div>
								</div>

							</div>
						</div>
					</template>

					<!-- 电子版 -->
					<template v-if="digitProducts.length">
						<div class="cart-type-label">电子版</div>
						<div
							v-for="(item, idx) in digitProducts"
							:key="'digit_' + idx"
							:class="['cart-option-item', { selected: item.checked }]"
							@click="toggleDigit(idx)"
						>
							<el-checkbox v-model="item.checked" class="cart-checkbox" @click.native.stop @change="toggleDigit(idx)"></el-checkbox>
							<div class="cart-option-left">
<!--								<div class="cart-option-icon pdf">-->
<!--									<i class="el-icon-tickets"></i>-->
<!--								</div>-->
								<div class="cart-option-info">
									<div class="cart-option-name">{{ info.standardCode}} {{ item.prdSpuName || 'PDF电子版' }}</div>
<!--									<div class="cart-option-sku" v-if="item.prdSkuName">{{ item.prdSkuName }}</div>-->
								</div>
							</div>
							<div class="cart-option-right">
								<div class="cart-price-box">
									<div class="cart-price-row">
										<span class="cart-now-price">¥{{ displayPrice(item) }}</span>
										<span class="cart-before-price" v-if="item.defaultPrice && displayPrice(item) < item.defaultPrice">¥{{ item.defaultPrice }}</span>
										<el-tag v-if="calcDiscount(item) !== null" size="mini" type="danger" class="cart-discount-tag">{{ calcDiscount(item) }}折</el-tag>
									</div>
									<div class="cart-vip-row" v-if="!isVipUser && item.vipPrice && item.vipPrice < item.curPrice">
										<span class="cart-vip-price">VIP ¥{{ item.vipPrice }}</span>
									</div>
<!--									<div class="cart-quantity"  @click.stop>-->
<!--										<el-input-number-->
<!--											v-model="item.curBuyNum"-->
<!--											:min="1"-->
<!--											:max="99"-->
<!--											size="mini"-->
<!--											controls-position="right"-->
<!--										></el-input-number>-->
<!--									</div>-->
								</div>

							</div>
						</div>
					</template>

					<!-- 智能文档版 -->
<!--					<template v-if="jsonProducts.length">-->
<!--						<div class="cart-type-label">智能文档版</div>-->
<!--						<div-->
<!--							v-for="(item, idx) in jsonProducts"-->
<!--							:key="'json_' + idx"-->
<!--							:class="['cart-option-item', { selected: item.checked }]"-->
<!--							@click="toggleJson(idx)"-->
<!--						>-->
<!--							<el-checkbox v-model="item.checked" class="cart-checkbox" @click.native.stop @change="toggleJson(idx)"></el-checkbox>-->
<!--							<div class="cart-option-left">-->
<!--								<div class="cart-option-icon json">-->
<!--									<i class="el-icon-cpu"></i>-->
<!--								</div>-->
<!--								<div class="cart-option-info">-->
<!--									<div class="cart-option-name">{{ item.prdSpuName || '智能文档版' }}</div>-->
<!--									<div class="cart-option-sku" v-if="item.prdSkuName">{{ item.prdSkuName }}</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="cart-option-right">-->
<!--								<div class="cart-price-box">-->
<!--									<div class="cart-price-row">-->
<!--										<span class="cart-now-price">¥{{ displayPrice(item) }}</span>-->
<!--										<span class="cart-before-price" v-if="item.defaultPrice && displayPrice(item) < item.defaultPrice">¥{{ item.defaultPrice }}</span>-->
<!--										<el-tag v-if="calcDiscount(item) !== null" size="mini" type="danger" class="cart-discount-tag">{{ calcDiscount(item) }}折</el-tag>-->
<!--									</div>-->
<!--									<div class="cart-vip-row" v-if="!isVipUser && item.vipPrice && item.vipPrice < item.curPrice">-->
<!--										<span class="cart-vip-price">VIP ¥{{ item.vipPrice }}</span>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</template>-->

					<!-- 无购买选项 -->
					<div class="cart-option-empty" v-if="!paperProducts.length && !digitProducts.length && !jsonProducts.length">
						<i class="el-icon-info"></i>
						<span class="cart-option-empty-text">暂无购买资源，如需要请与销售人员联系</span>
						<span class="cart-option-empty-phone">联系电话：18911620150</span>
					</div>
				</div>

				<!-- 底部汇总 + 操作 -->
				<div class="cart-footer" v-if="hasAnyOption">
					<div class="cart-footer-summary">
<!--						<span v-if="totalQuantity > 0">已选 <strong>{{ totalQuantity }}</strong> 件，合计</span>-->
<!--						<span class="cart-footer-total" v-if="totalPrice > 0">-->
<!--							¥{{ totalPrice.toFixed(2) }}-->
<!--						</span>-->
					</div>
					<el-button
						type="primary"
						size="medium"
						:disabled="totalQuantity === 0"
						:loading="adding"
						@click="handleBatchAddCart"
					>
						<i class="el-icon-shopping-cart-2"></i> 加入购物车
					</el-button>
				</div>
			</template>
		</div>
	</el-dialog>
</template>

<script>
import { getStandardDet } from '@/api/standards/det';
import { mapGetters, mapActions } from 'vuex';
import TMessage from '@/utils/TMessage';
import TMessageBox from '@/utils/TMessageBox';

export default {
	name: 'DialogAddCart',
	data() {
		return {
			visible: false,
			loading: false,
			adding: false,
			info: null,
			standardId: '',
			paperProducts: [],
			digitProducts: [],
			jsonProducts: []
		};
	},
	computed: {
		...mapGetters('User', ['uisLogin', 'uinfo']),
		isVipUser() {
			if (!this.uinfo) return false;
			const hasLevel = this.uinfo.levelId && this.uinfo.levelId !== 0;
			const now = new Date().getTime();
			const levelEndValid = this.uinfo.levelEnd && new Date(this.uinfo.levelEnd).getTime() > now;
			return hasLevel && levelEndValid;
		},
		hasAnyOption() {
			return this.paperProducts.length > 0 || this.digitProducts.length > 0 || this.jsonProducts.length > 0;
		},
		lifeTagType() {
			if (!this.info || !this.info.lifeName) return 'info';
			const n = this.info.lifeName;
			if (n.includes('现行') || n.includes('有效')) return 'success';
			if (n.includes('征求意见')) return 'warning';
			if (n.includes('即将实施')) return '';
			return 'danger';
		},
		totalQuantity() {
			let count = 0;
			this.allProducts().forEach(item => {
				if (item.checked) count += item.curBuyNum || 1;
			});
			return count;
		},
		totalPrice() {
			let price = 0;
			this.allProducts().forEach(item => {
				if (item.checked) {
					price += this.displayPrice(item) * (item.curBuyNum || 1);
				}
			});
			return price;
		}
	},
	methods: {
		...mapActions('Settings', ['setLoginShow']),

		allProducts() {
			return [...this.paperProducts, ...this.digitProducts, ...this.jsonProducts];
		},

		displayPrice(item) {
			if (!item) return 0;
			return this.isVipUser ? (item.vipPrice || item.curPrice || 0) : (item.curPrice || 0);
		},

		calcDiscount(item) {
			const dp = this.displayPrice(item);
			const orig = item.defaultPrice;
			if (!dp || !orig || orig <= 0 || dp >= orig) return null;
			return (dp / orig * 10).toFixed(1);
		},

		open(standardId) {
			if (!this.uisLogin) {
				this.setLoginShow(true);
				return;
			}
			this.standardId = standardId;
			this.resetForm();
			this.visible = true;
			this.loadData();
		},

		resetForm() {
			this.info = null;
			this.paperProducts = [];
			this.digitProducts = [];
			this.jsonProducts = [];
		},

		async loadData() {
			this.loading = true;
			try {
				const res = await getStandardDet(this.standardId);
				if (res.code === 200) {
					this.info = res.data;
					this.paperProducts = (res.data.paperStandardProduct || []).map(p => ({ ...p, checked: false, curBuyNum: 1 }));
					this.digitProducts = (res.data.digitStandardProduct || []).map(p => ({ ...p, checked: false, curBuyNum: 1 }));
					this.jsonProducts = (res.data.jsonStandardProduct || []).map(p => ({ ...p, checked: false, curBuyNum: 1 }));
				}
			} catch (e) {
				console.error('加载标准详情失败', e);
			} finally {
				this.loading = false;
			}
		},

		togglePaper(idx) {
			this.$set(this.paperProducts, idx, { ...this.paperProducts[idx], checked: !this.paperProducts[idx].checked });
		},
		toggleDigit(idx) {
			this.$set(this.digitProducts, idx, { ...this.digitProducts[idx], checked: !this.digitProducts[idx].checked });
		},
		toggleJson(idx) {
			this.$set(this.jsonProducts, idx, { ...this.jsonProducts[idx], checked: !this.jsonProducts[idx].checked });
		},

		async handleBatchAddCart() {
			const items = [];
			this.allProducts().forEach(item => {
				if (item.checked) {
					items.push({
						skuId: item.prdSkuId,
						buyNum: item.curBuyNum || 1
					});
				}
			});

			if (items.length === 0) {
				TMessage.warning('请选择要购买的版本');
				return;
			}

			this.adding = true;
			try {
				await this.$store.dispatch('Cart/addCart', { goodList: items });
				TMessageBox.confirm('恭喜！商品已加入购物车。', '提示', { confirmButtonText: '去结算' }).then(() => {
					this.visible = false;
					this.$router.push({ path: '/Cart' });
				}).catch(() => {
					this.visible = false;
				});
			} catch (e) {
				TMessage.error('添加失败，请稍后重试');
			} finally {
				this.adding = false;
			}
		},

		handleClose() {
			this.standardId = '';
			this.resetForm();
		}
	}
};
</script>

<style lang="less" scoped>
/deep/ .dialog-add-cart {
	.el-dialog__header { padding: 20px 24px 0; }
	.el-dialog__title { font-size: 18px; font-weight: 700; color: #0f172a; }
	.el-dialog__body { padding: 16px 24px 24px; }
}

.cart-product-info {
	padding: 16px 20px;
	background: #f8fafc;
	border-radius: 12px;
	border: 1px solid #e2e8f0;
	margin-bottom: 20px;
}

.cart-product-header {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 10px;
	flex-wrap: wrap;
}

.cart-product-code {
	font-size: 14px;
	font-weight: 700;
	color: #155dfc;
	background: #eff6ff;
	padding: 3px 12px;
	border-radius: 6px;
}

.cart-product-name {
	margin: 0 0 8px;
	font-size: 16px;
	font-weight: 700;
	color: #0f172a;
	line-height: 1.5;
}

.cart-product-meta {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	font-size: 12px;
	color: #94a3b8;
	i { color: #94a3b8; margin-right: 2px; }
}

.cart-option-title {
	font-size: 14px;
	font-weight: 600;
	color: #475569;
	margin-bottom: 12px;
	padding-bottom: 10px;
	border-bottom: 1px dashed #e2e8f0;
}

.cart-option-list {
	display: flex;
	flex-direction: column;
	gap: 0;
}

.cart-type-label {
	font-size: 15px;
	font-weight: 600;
	color: #0f172a;
	margin: 12px 0 8px;
	padding-left: 4px;
}

.cart-option-item {
	display: flex;
	//align-items: center;
	padding: 14px 16px;
	border: 1px solid #e2e8f0;
	border-radius: 10px;
	background: #fff;
	transition: border-color 0.2s, background 0.2s;
	cursor: pointer;
	margin-bottom: 8px;

	&:hover { border-color: #bfdbfe; }
	&.selected {
		border-color: #155dfc;
		background: #f8faff;
	}
}

.cart-checkbox {
	flex-shrink: 0;
	margin-right: 12px;
	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #155dfc;
		border-color: #155dfc;
	}
}

.cart-option-left {
	display: flex;
	//align-items: center;
	gap: 12px;
	flex: 1;
	min-width: 0;
}

.cart-option-icon {
	width: 40px;
	height: 40px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	i { font-size: 18px; }
	&.paper { background: #eff6ff; i { color: #155dfc; } }
	&.pdf { background: #fef3c7; i { color: #d97706; } }
	&.json { background: #f3e8ff; i { color: #7c3aed; } }
}

.cart-option-info { min-width: 0;margin-left: 12px; }
.cart-option-name {
	font-size: 14px;
	font-weight: 600;
	color: #0f172a;
	margin-bottom: 2px;
}
.cart-option-sku {
	font-size: 12px;
	color: #94a3b8;
	margin-top: 2px;
}

.cart-option-right {
	display: flex;
	align-items: center;
	gap: 12px;
	flex-shrink: 0;
	margin-left: 16px;
}

.cart-price-box {
	display: flex;
	flex-direction: column;
	gap: 4px;
	align-items: flex-end;
}

.cart-price-row {
	display: flex;
	align-items: center;
	gap: 8px;
	white-space: nowrap;
}

.cart-now-price {
	font-size: 16px;
	font-weight: 700;
	color: #ef4444;
}

.cart-before-price {
	font-size: 12px;
	color: #969696;
	text-decoration: line-through;
}

.cart-discount-tag {
	border: none;
	padding: 0 6px;
	height: 20px;
	line-height: 20px;
}

.cart-vip-row {
	font-size: 12px;
}

.cart-vip-price {
	color: #155dfc;
	font-weight: 500;
}

.cart-quantity {
	/deep/ .el-input-number--mini { width: 100px; }
	/deep/ .el-input-number__decrease,
	/deep/ .el-input-number__increase {
		background: #f8fafc;
		border-color: #e2e8f0;
		color: #475569;
	}
}

.cart-option-empty {

	display: flex;

flex-direction: column;

	align-items: center;

	justify-content: center;

	gap: 8px;

	padding: 32px 0;

gap: 6px;

padding: 40px 20px;

	color: #94a3b8;

	font-size: 14px;

	i { font-size: 18px; }

text-align: center;


	i {

	font-size: 36px;

	color: #cbd5e1;

	margin-bottom: 8px;

	}


	.cart-option-empty-text {

		display: block;

	line-height: 1.6;

	}


	.cart-option-empty-phone {

	font-size: 15px;

	font-weight: 600;

	color: #64748b;

	margin-top: 4px;

	}

}


// 底部汇总
.cart-footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
	padding: 16px 20px;
	background: #f8fafc;
	border-radius: 12px;
	//border: 1px solid #e2e8f0;
}

.cart-footer-summary {
	font-size: 14px;
	color: #475569;
	strong { color: #0f172a; font-size: 16px; }
}

.cart-footer-total {
	font-size: 22px;
	font-weight: 700;
	color: #ef4444;
	margin-left: 8px;
}

/deep/ .cart-footer .el-button--primary {
	background-color: #155dfc;
	border-color: #155dfc;
	padding: 10px 24px;
	font-size: 14px;
	font-weight: 600;
	border-radius: 10px;
	i { margin-right: 4px; }
}
</style>
